const collectionFilterOptions = [
  {
    label: 'IDs (lowest)',
    value: 'lowest',
  },
  {
    label: 'IDs (highest)',
    value: 'highest',
  },
  {
    label: 'Rarity (most)',
    value: 'most',
  },
  {
    label: 'Rarity (least)',
    value: 'least',
  },
  {
    label: 'Price (highest)',
    value: 'highprice',
  },
  {
    label: 'Price (lowest)',
    value: 'lowprice',
  }
]

const myCollectionOptions = [
  {
    label: 'Recently Added',
    value: 'recent',
  },
  {
    label: 'Oldest',
    value: 'oldest',
  },
]

export { collectionFilterOptions, myCollectionOptions }